import { verticalScale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  detailsStyle: { flexDirection: 'row', marginTop: verticalScale(4) },
  rtsFooter: { alignSelf: 'flex-end', flex: 1, flexDirection: 'row' },
});
export default styles;
